import ReactGA from 'react-ga4';

// Initialize with your GA4 Measurement ID
const GA_MEASUREMENT_ID = 'G-2CM6JFV159';

export const initGA = () => {
  if (process.env.NODE_ENV === 'production' && GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('GA Initialized');
  }
};

// Track page views
export const trackPageView = (path) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.send({ 
      hitType: "pageview", 
      page: path,
      title: document.title
    });
    console.log('Page view tracked:', path);
  }
};

// Track custom events
export const trackEvent = (category, action, label, value) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
      value: value
    });
    console.log('Event tracked:', { category, action, label, value });
  }
};

// Track form submissions
export const trackFormSubmit = (formName) => {
  trackEvent('Form', 'Submit', formName);
};

// Track button clicks
export const trackButtonClick = (buttonName) => {
  trackEvent('Button', 'Click', buttonName);
};
